<div class="row" style="margin-top:65px">
  <div class="col-12">
    <a [routerLink]="'/user-dashboard'">
      <i class="fas fa-fw fa-home me-2"></i>Home<i class="fas fa-fw fa-chevron-right mx-2"></i>
    </a>
    <a [routerLink]="'/admin/billing'">
      <i class="fas fa-fw fa-file-invoice-dollar me-2"></i>Billing Center<i class="fas fa-fw fa-chevron-right mx-2"></i>
    </a>
    <span class="c_bluedk"><i class="fas fa-fw fa-cog mx-2"></i>Data Manager</span>
  </div>
</div>
<div class="row my-3">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <!-- Upload Type -->
        <div class="row">
          <div class="col-12">
            <label for="uploadType" class="bolder">Upload Type</label>
            <select id="uploadType"
                    class="form-select form-select-sm"
                    [(ngModel)]="selectedTemplateId"
                    (ngModelChange)="onTemplateChange($event)">
              <option [ngValue]="null" disabled>Select upload type…</option>
              <option *ngFor="let t of templateTypes" [ngValue]="t.template_id">
                {{ t.template_name }} (→ {{ t.import_table }})
              </option>
            </select>

            <div class="muted d-none" *ngIf="selectedTemplate as st">
              Selected: <strong>{{ st.template_name }}</strong>
              <span *ngIf="st.import_table"> → {{ st.import_table }}</span>
            </div>
          </div>
        </div>
        <!-- File chooser -->
        <div class="row">
          <div class="col-12">
            <label for="excelFile" class="bolder">Choose Excel File</label>
            <div class="normal">
              <input id="excelFile" type="file" accept=".xlsx,.xls" (change)="onFileSelect($event)" />
              <div class="muted d-none" *ngIf="fileName">Selected: {{ fileName }}</div>
            </div>
          </div>
        </div>
        <div *ngIf="progress >= 0" class="row">
          <div class="muted">Upload: {{ progress }}%</div>
          <div class="progress">
            <div class="bar" [style.width.%]="progress"></div>
          </div>
        </div>

        <div *ngIf="message" class="msg"
             [class.ok]="message.includes('complete')"
             [class.err]="message.includes('error') || message.includes('failed')">
          {{ message }}
        </div>
      </div>
      <div class="card-footer">
        <button (click)="importNow()" [disabled]="!canImport" class="btn btn-sm btn-dark me-2">
          {{ isImporting ? 'Importing…' : 'Import' }}
        </button>
        <button class="btn btn-sm btn-outline-dark" (click)="reset()">Reset</button>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="grid_sizer" id="sizeDataManager" style="height:50vh">
      <ag-grid-angular class="ag-theme-alpine"
                       [rowData]="rowData"
                       [columnDefs]="columnDefs"
                       [getRowStyle]="getRowStyle"
                       [rowHeight]="28"
                       [headerHeight]="32"
                       (gridReady)="onGridReady($event)"
                       [rowSelection]="rowSelection"
                       (selectionChanged)="onSelectionChanged($event)"
                       [pagination]="false"
                       style="width: 100%;height:100%;border:0 !important">
      </ag-grid-angular>
    </div>
  </div>
</div>
